(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noxe-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNoxeReveal(root) {
      var items = (root || document).querySelectorAll('.noxe-reveal:not(.in)');
      if (!items.length) return;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach(function (el) { el.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      items.forEach(function (el) {
        io.observe(el);
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('in');
          io.unobserve(el);
        }
      });
      window.setTimeout(function () {
        (root || document).querySelectorAll('.noxe-reveal:not(.in)').forEach(function (el) {
          el.classList.add('in');
        });
      }, 2000);
    }
    document.addEventListener('DOMContentLoaded', function () { initNoxeReveal(); });
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { initNoxeReveal(e.target); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
